module.exports = __webpack_public_path__ + "img/kmrc_logo.3fb5a50f.png";